class StateManager {
    constructor() {
        this.eventSubscribers = {};
        this.eventQueues = {};
    }

    // Subscribe to an event key
    subscribe(event, callback) {
        debugger;
        if (!this.eventSubscribers[event]) {
            this.eventSubscribers[event] = [];
        }
        this.eventSubscribers[event].push(callback);

        // Process queued events for this event
        if (this.eventQueues[event] && this.eventQueues[event].length > 0) {
            this.eventQueues[event].forEach(data => callback(data));
            this.eventQueues[event] = []; // Clear the queue after processing
        }
    }

    // Unsubscribe from an event key
    unsubscribe(event, callback) {
        if (!this.eventSubscribers[event]) return;

        this.eventSubscribers[event] = this.eventSubscribers[event].filter(cb => cb !== callback);
    }

    // Publish data to an event key
    publish(event, data) {
        debugger;
        if (!this.eventSubscribers[event] || this.eventSubscribers[event].length === 0) {
            // If no subscribers, queue the event
            if (!this.eventQueues[event]) {
                this.eventQueues[event] = [];
            }
            this.eventQueues[event].push(data);
        } else {
            // If there are subscribers, dispatch the event immediately
            this.eventSubscribers[event].forEach(callback => callback(data));
        }
    }
}

var stateManager;
if (!stateManager) {
    stateManager = new StateManager();
}